



























import Vue, { PropType } from "vue";

import _ from "lodash";
import { AggregationTypeEnum } from "@/model/data/dashboard/AggregationTypeEnum";
import { TransCountType } from "@/model/data/dashboard/TransCountType";
import { DashboardWidget } from "@/model/data/dashboard/DashboardWidget";

export default Vue.extend({
    props: {
        widget: Object as PropType<DashboardWidget>,
    },
    computed: {
        availableTimeOfDayDetails() {
            var res = [
                { value: 0, text: this.$t("common.no") },
                { value: 5, text: this.$tc("common.minute", 5, { count: 5 }) },
                { value: 10, text: this.$tc("common.minute", 10, { count: 10 }) },
                { value: 15, text: this.$tc("common.minute", 15, { count: 15 }) },
                { value: 30, text: this.$tc("common.minute", 30, { count: 30 }) },
                { value: 60, text: this.$tc("common.hour", 1, { count: 1 }) },
            ];

            return res;
        },
        availableCountType() {
            var res = [];

            res.push({
                text: this.$t("dashboard.widget_transactions.count_type.average_value"),
                value: TransCountType.AverageValue,
            });

            res.push({
                text: this.$t("dashboard.widget_transactions.count_type.total_value"),
                value: TransCountType.TotalValue,
            });

            res.push({
                text: this.$t("dashboard.widget_transactions.count_type.average_pieces_count"),
                value: TransCountType.AveragePiecesCount,
            });

            res.push({
                text: this.$t("dashboard.widget_transactions.count_type.total_pieces_count"),
                value: TransCountType.TotalPiecesCount,
            });
            res.push({
                text: this.$t("dashboard.widget_transactions.count_type.average_operation_count"),
                value: TransCountType.AverageOperationCount,
            });

            res.push({
                text: this.$t("dashboard.widget_transactions.count_type.total_operation_count"),
                value: TransCountType.TotalOperationCount,
            });

            res.push({
                text: this.$t("dashboard.widget_transactions.count_type.denomination_distribution"),
                value: TransCountType.DenominationDistribution,
            });

            return res;
        },
        availableAggregationTypes() {
            var res = [];

            res.push({
                text: this.$t("dashboard.widget_transactions.aggregation_type.aggregate_by_time_of_day"),
                value: AggregationTypeEnum.AggregateByTimeOfDay,
            });

            res.push({
                text: this.$t("dashboard.widget_transactions.aggregation_type.aggregate_by_month"),
                value: AggregationTypeEnum.AggregateByMonth,
            });

            res.push({
                text: this.$t("dashboard.widget_transactions.aggregation_type.aggregate_by_day_of_week"),
                value: AggregationTypeEnum.AggregateByDayOfWeek,
            });

            res.push({
                text: this.$t("dashboard.widget_transactions.aggregation_type.timeline_by_hours"),
                value: AggregationTypeEnum.TimelineByHours,
            });

            res.push({
                text: this.$t("dashboard.widget_transactions.aggregation_type.timeline_by_day"),
                value: AggregationTypeEnum.TimelineByDay,
            });

            res.push({
                text: this.$t("dashboard.widget_transactions.aggregation_type.timeline_by_month"),
                value: AggregationTypeEnum.TimelineByMonth,
            });

            res.push({
                text: this.$t("dashboard.widget_transactions.aggregation_type.absolute_value"),
                value: AggregationTypeEnum.AbsoluteValue,
            });

            return res;
        },
    },
});
